function ensureExhaustive(_: never): never {
	// eslint-disable-next-line no-console
	console.log(_);
	throw new Error("Shouldn't have gotten here, exhaustive switch check");
}

export { ensureExhaustive };
